import { Component, OnInit } from '@angular/core';
import { Theme } from '../../data/theme.model';
import { tap } from 'rxjs';
import { ApiService } from '../../data/api.service';
import { StoreService } from '../../data/store.service';
import { I18ns } from '../../utils/i18n/I18n';
import { SharedModule } from '../../utils/shared.module';
import { RouterLink } from '@angular/router';
import { ThemeListRecord } from '../../data/pocketbase-type';
import { Flag, flagList } from '../../data/flags';

@Component({
  selector: 'app-themes',
  standalone: true,
  imports: [SharedModule, RouterLink],
  templateUrl: './themes.component.html',
  styleUrl: './themes.component.scss',
})
export class ThemesComponent implements OnInit {
  themes: ThemeListRecord[] = [];
  pageIndex = 1;
  pageSize = 15;
  themesCount = 0;
  showLangs = false;
  protected readonly I18ns = I18ns;
  protected readonly flagList = flagList;

  constructor(
    private readonly api: ApiService,
    public readonly store: StoreService,
  ) {}

  ngOnInit() {
    this.loadThemes();
  }

  loadThemes(reset = false) {
    this.api
      .getThemes(this.pageIndex, this.pageSize, this.store.defaultLang())
      .pipe(
        tap((res) => {
          if (reset) {
            this.themes = res.items;
          } else {
            this.themes = [...this.themes, ...res.items];
          }
          this.themesCount = res.totalItems;
        }),
      )
      .subscribe();
  }

  showMoreThemes() {
    this.pageIndex++;
    this.loadThemes();
  }

  goToTheme(theme: ThemeListRecord) {
    this.store.themeId.set(theme.id);
  }

  getFlag(lang: string | undefined) {
    if (lang) {
      return flagList.find((f) => f.tag === lang)?.flag || '';
    }
    return '';
  }

  pickLang(lg: Flag | null) {
    this.store.defaultLang.set(lg);
    this.loadThemes(true);
  }
}
